module.exports = __webpack_public_path__ + "fonts/SohoStd-Regular.90084d5.woff";